import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HeaderNsideService } from '../../services/HeaderNside.service';
import { Noti } from '../../models/Notification.model';
import { Subscription, interval } from 'rxjs';
import { WebUserDetails } from '../../../../shared/models/WebUserDetails';
import { SaPaypalServiceService } from '../../services/SaPaypalService.service';
import { SaAddMembersModal } from '../../models/SaAddMembersModel';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { format } from 'url';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  notSubcription: Subscription;
  adminName: string;
  notifications: Noti[];
  showSession: boolean = false;
  notCount: number;
  allUsers: WebUserDetails[];
  emailProcessing: boolean;
  emailIsValid: boolean;
  emailReturn: any;
  emailProcessing2: boolean;
  emailIsValid2: boolean;
  emailReturn2: any;
  addUserClick: boolean = false;
  updateDeleteUserClick: boolean = false;
  updateName: string = '';
  updateEmail: string = '';
  memberId: string = '';
  memberName: string = '';
  memberEmailId: string = '';
  addNameControlLabel: string = '';
  addEmailControlLabel: string = '';
  updateNameControlLabel: string = '';
  updateEmailControlLabel: string = '';
  totalMemberCount: number = 0;
  remainingMemberCount: number = 0;
  memberList: SaAddMembersModal[] = [];
  updateList: boolean = false;
  oldPwd: string = '';
  newPwd: string = '';
  rePwd: string = '';
  navCounterSa: number = 0;
  elementNavSa: HTMLElement;
  loaderHeaderUpdate: boolean = false;
  loaderHeaderDelete: boolean = false;
  loaderHeaderSave: boolean = false;
  constructor(private router: Router, private HeaderService: HeaderNsideService, private PaypalService: SaPaypalServiceService) {


  }

  ngOnInit() {
    this.addUserClick = false;
    this.updateList = false;
    this.updateDeleteUserClick = false;
    if (this.HeaderService.subsVar == undefined) {
      this.HeaderService.subsVar = this.HeaderService.
        invokeFirstComponentFunction.subscribe((name: string) => {
          this.setModalFalse();
        });
    } else {
      this.HeaderService.subsVar = this.HeaderService.
        invokeFirstComponentFunction.subscribe((name: string) => {
          this.setModalFalse();
        });
    }
    this.getAdminName();
    this.checkUpdation();
    this.getNotifications();
    this.getBusinessPartnerList();
    if (this.HeaderService.subsVarSASidebar == undefined) {
      this.HeaderService.subsVarSASidebar = this.HeaderService.
        invokeFirstComponentFunctionSidebarSA.subscribe((name: string) => {
          this.openCloseNav();
        });
    } else {
      this.HeaderService.subsVarSASidebar = this.HeaderService.
        invokeFirstComponentFunctionSidebarSA.subscribe((name: string) => {
          this.openCloseNav();
        });
    }

  }

  getAdminName() {
    this.HeaderService.getHeaderData().subscribe(
    (result) => {
      this.adminName = result['Name'];
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not get info!', AlertType.Error);
      alert('Something went wrong with Authentication, logging you out!');
      this.logout();

    });
  }

  setModalFalse() {
    this.addUserClick = false;
    this.updateList = false;
    this.updateDeleteUserClick = false;
  }

  // member code
  emailCheck() {

    if (this.updateEmailControlLabel.includes('@') && this.updateEmailControlLabel.length > 4) {
      this.emailProcessing = true;
      this.PaypalService.checkEmailIsValid(this.updateEmailControlLabel.toLowerCase(), this.memberId).subscribe(
      (x) => {
        this.emailReturn = x;
        this.emailProcessing = false;
        if (this.emailReturn == null) {
          this.emailReturn = false;
      }
      this.emailIsValid = this.emailReturn;
    },
      (error) => {
        AlertMessages.Show('Failed', 'Could not check email!', AlertType.Error);
      });
    }
  }

  emailCheck2() {

    if (this.addEmailControlLabel.includes('@') && this.addEmailControlLabel.length > 4) {
      this.emailProcessing2 = true;
      this.PaypalService.checkEmailIsValid(this.addEmailControlLabel.toLowerCase(), this.memberId).subscribe(
      (x) => {
        this.emailReturn2 = x;
        this.emailProcessing2 = false;
        if (this.emailReturn2 == null) {
          this.emailReturn2 = false;
        }
        this.emailIsValid2 = this.emailReturn2;
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not check email!', AlertType.Error);
      });

    }
  }

  getBusinessPartnerList() {
    this.PaypalService.getBusinessPartnerList().subscribe(
    (data) => {
      this.memberList = data as SaAddMembersModal[];
      this.memberList.forEach((i) => {
        i.shortName = '';
        const chars: string[] = i.name.split(' ');
        for (let j = 0; j < chars.length; j++) {
          i.shortName += chars[j][0];
        }
      });

      if (this.memberList !== undefined && this.memberList !== null) {
        this.totalMemberCount = this.memberList.length;
        this.remainingMemberCount = this.totalMemberCount - 5;
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load Administrators!', AlertType.Error);
    });
  }

  updateListClick() {
    this.updateList = true;
  }

  onCancelUserListClick() {
    this.updateList = false;
  }

  onAddUserClick() {

    this.loaderHeaderSave = false;
    this.addUserClick = true;
    this.updateDeleteUserClick = false;
    this.updateList = false;
    // this.addEmailControlLabel = "";
    // this.addNameControlLabel = "";
    // this.updateEmailControlLabel = "";
    // this.updateNameControlLabel = "";
    this.resetLabels();
    this.resetMember();
    // this.memberEmailId = "";
    // this.memberId = "";
    // this.memberName = "";
    this.emailIsValid2 = false;
  }

  onUpdateDeleteClick(id, name, email) {
    this.loaderHeaderDelete = false;
    this.loaderHeaderUpdate = false;
    this.updateList = false;
    this.updateDeleteUserClick = true;
    this.memberEmailId = '';
    this.memberName = '';
    this.updateNameControlLabel = '';
    this.updateEmailControlLabel = '';
    this.memberId = id;
    this.memberName = name;
    this.memberEmailId = email;
    this.updateNameControlLabel = name;
    this.updateEmailControlLabel = email;
    this.emailIsValid = true;

  }

  onCancelAddClick(form) {
    this.loaderHeaderSave = false;
    form.reset();
    // this.addNameControlLabel = "";
    // this.addEmailControlLabel = "";
    // this.updateEmailControlLabel = "";
    // this.updateNameControlLabel = "";
    this.resetLabels();
    this.addUserClick = false;
    this.memberId = '';
  }

  onCancelUpdateClick(form) {
    // this.loaderHeaderDelete = false;
    // this.loaderHeaderUpdate = false;
    form.reset();
    // this.memberId = "";
    // this.memberEmailId = "";
    // this.memberName = "";
    // this.addNameControlLabel = "";
    // this.addEmailControlLabel = "";
    // this.updateEmailControlLabel = "";
    // this.updateNameControlLabel = "";
    this.resetMember();
    this.resetLabels();
    this.setLoaderFalse();
    // this.updateDeleteUserClick = false;
    this.loaderHeaderUpdate = false;
  }

  onDeleteClick() {
    this.loaderHeaderDelete = true;
    this.PaypalService.deleteBusinessPartner(this.memberId).subscribe(
    (data) => {
      if (data == true) {
        var indexDelete = this.memberList.findIndex(ij => ij.id == this.memberId);
        this.memberList.splice(indexDelete, 1);
        this.totalMemberCount = this.totalMemberCount - 1;
        this.remainingMemberCount = this.totalMemberCount - 5;
        AlertMessages.Show('Success', 'Deleted Successfully', AlertType.Success);
        // this.updateDeleteUserClick = false;
        this.resetMember();
        this.resetLabels();
        this.setLoaderFalse();
        // this.memberId = "";
        // this.memberEmailId = "";
        // this.memberName = "";
        // this.addNameControlLabel = "";
        // this.addEmailControlLabel = "";
        // this.updateEmailControlLabel = "";
        // this.updateNameControlLabel = "";
        // this.loaderHeaderDelete = false;
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not delete!', AlertType.Error);
      this.resetMember();
      this.resetLabels();
      this.setLoaderFalse();
    });
  }


  onUserAdd(form) {
    let nameVal = form.value.TagLabelname;
    let emailVal = form.value.TagLabelemail;
    this.memberId = '';
    this.loaderHeaderSave = true;
    this.PaypalService.addPartner(nameVal, emailVal).subscribe(
    (data) => {
      let ShortNamee = '';

      const characters = nameVal.split(' ');
      for (let j = 0; j < characters.length; j++) {
        ShortNamee += characters[j][0];
      }
      if (data['Id'] != 0) {
        const InsertedValue = {
          id: data['ReturnedId'],
          name: nameVal,
          emailId: emailVal,
          shortName: ShortNamee
        };

        this.memberList.splice(0, 0, InsertedValue);
        this.totalMemberCount = this.totalMemberCount + 1;
        this.remainingMemberCount = this.totalMemberCount - 5;
        // form.reset();
        AlertMessages.Show('ALERT', data['StatusMessage'], AlertType.Success);
        // this.addUserClick = false;
        // this.loaderHeaderSave = false;
        // this.addUserClick = false;
        // this.emailIsValid2 = false;
        this.setFalse(form);

      } else {
        // form.reset();
        // AlertMessages.Show('ALERT', data['StatusMessage'], AlertType.Error);
        // this.addUserClick = false;
        // this.loaderHeaderSave = false;
        // this.addUserClick = false;
        // this.emailIsValid2 = false;
        // this.setFalse(form);
      }
    },
    (error) => {
      // form.reset();
      AlertMessages.Show('Failed', 'Could not Add!', AlertType.Error);
      this.setFalse(form);
    });
  }

  onUserUpdate(form) {
    this.loaderHeaderUpdate = true;
    this.PaypalService.updateBusinessPartnerDetail(this.memberId, form.value.TagLabelnameup, form.value.TagLabelmailup).subscribe(
    (data) => {
      if (data == true) {
        let ShortNamee = '';
        const characters = form.value.TagLabelnameup.split(' ');
        for (let j = 0; j < characters.length; j++) {
          ShortNamee += characters[j][0];
        }
        var indexUpdate = this.memberList.findIndex(ij => ij.id == this.memberId);
        this.memberList[indexUpdate].name = form.value.TagLabelnameup;
        this.memberList[indexUpdate].emailId = form.value.TagLabelmailup;
        this.memberList[indexUpdate].shortName = ShortNamee;
        AlertMessages.Show('Success', 'Member Updated Successfully!!!', AlertType.Success);
        // this.memberId = "";
        // this.memberEmailId = "";
        // this.memberName = "";
        // this.updateNameControlLabel = "";
        // this.updateEmailControlLabel = "";
        // this.addNameControlLabel = "";
        // this.addEmailControlLabel = "";
        this.resetMember();
        this.resetLabels();
        // this.updateDeleteUserClick = false;
        // this.loaderHeaderUpdate = true;
        // this.updateList = false;
      } else {
        // this.updateDeleteUserClick = false;
        // this.loaderHeaderUpdate = true;
        // this.updateList = false;
      }
    },
    (error) => {
      AlertMessages.Show('Error', 'Member Not Updated!!!', AlertType.Error);

    }).add(() => {
      this.updateDeleteUserClick = false;
      this.loaderHeaderUpdate = true;
      this.updateList = false;
    });
  }

  //member code ends here
  checkUpdation() {
    this.notSubcription = interval(100000).subscribe((val) => {
      this.getNotifications();
    });
  }

  getNotifications() {
    this.HeaderService.getNotifications().subscribe(
    (data) => {
      this.notifications = data as Noti[];
      this.notCount = this.notifications.filter(i => i.isNew == true).length;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load notifications', AlertType.Error);
    });
  }


  deleteNot() {

    const newNots = this.notifications.filter(newNote => newNote.isNew == true);
    const delNots = [];
    newNots.forEach((i) => {
      delNots.push(i.id);
    });

    if (delNots.length > 0) {
      this.HeaderService.removeNotification(delNots).subscribe(
        (Data) => {
          this.notCount = 0;
        },
        (error) => {
          AlertMessages.Show('Failed', 'Could not get!', AlertType.Error);
      });
    }
  }

  openCloseNav() {
    this.elementNavSa = document.getElementById('nav') as HTMLElement;
    const display = this.navCounterSa == 0 ? 'block' : 'none';
    const counter = this.navCounterSa == 0 ? 1 : 0;
    this.elementNavSa.style.display = display;
    this.navCounterSa = counter;

  }

  // toggleNav() {
  //   alert('nav toggle');
  // }

  logout() {
    this.notSubcription.unsubscribe();
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
    this.allUsers.splice(this.allUsers.findIndex(i => i.id == JSON.parse(sessionStorage.getItem('Id'))), 1);
    localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
    sessionStorage.clear();
    this.showSession = false;
    this.router.navigate(['/login']);
  }

  onSubmit(Form: NgForm) {
    let newpassword: string = Form.value.newPwd;

    setTimeout(() => {
      this.HeaderService.changePassword(Form.value.oldPwd, Form.value.newPwd, Form.value.rePwd).subscribe(
      (message) => {
        // if (message["Id"] == 1) {
        //   AlertMessages.Show("Success", message["StatusMessage"], AlertType.Success);
        //   Form.reset();
        // } else {
        //   AlertMessages.Show("Error", message["StatusMessage"], AlertType.Error);
        //   Form.reset();
        // }
        message['Id'] == 1 ? AlertMessages.Show('Success', message['StatusMessage'], AlertType.Success) : AlertMessages.Show('Error', message['StatusMessage'], AlertType.Error);
        Form.reset();
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not change!', AlertType.Error);
      });
    }, 200);
  }

  clearData(Form: NgForm) {
    Form.reset();

  }

  continueSession() {
    this.showSession = false;
  }

  public handleUserInactivity() {
    this.showSession = true;
  }

  //-------------------------------------------------------
  resetLabels() {
    this.updateNameControlLabel = '';
    this.updateEmailControlLabel = '';
    this.addNameControlLabel = '';
    this.addEmailControlLabel = '';
  }

  resetMember() {
    this.memberId = '';
    this.memberEmailId = '';
    this.memberName = '';
  }

  setFalse(form) {
    form.reset();
    this.addUserClick = false;
    this.loaderHeaderSave = false;
    this.addUserClick = false;
    this.emailIsValid2 = false;
  }

  setLoaderFalse() {
    this.updateDeleteUserClick = false;
    this.loaderHeaderDelete = false;
  }

  // noSpecialChar(event): boolean {
  //   const charCode = (event.which) ? event.which : event.keyCode;
  //   if (!((charCode >= 65) && (charCode <= 90) || (charCode >= 97) && (charCode <= 122) || (charCode >= 48) && (charCode <= 57))) {
  //     AlertMessages.Show('Warning', 'Special Characters are not allowed!!!', AlertType.Warning);
  //     return false;
  //   }
  //   return true;
  // }

}
